export function initScrollToTop() {
  // Allow pages to opt out of the scroll-to-top button
  if (document.body && document.body.classList.contains('no-scroll-top')) {
    return;
  }

  const scrollBtn = document.getElementById('scrollTopBtn');
  const footer = document.querySelector('footer');

  if (!scrollBtn) return;

  // Function to scroll smoothly to the top
  function scrollToTop() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  // Attach click event to button
  scrollBtn.addEventListener('click', scrollToTop);

  // Show/hide button based on scroll position
  window.addEventListener('scroll', function () {
    const showAfter = 400; // px

    if (window.scrollY > showAfter) {
      scrollBtn.style.display = 'block';
    } else {
      scrollBtn.style.display = 'none';
    }

    // Adjust button position if footer is visible
    if (footer) {
      const footerTop = footer.getBoundingClientRect().top;
      const windowHeight = window.innerHeight;

      scrollBtn.style.bottom = footerTop < windowHeight
        ? `${windowHeight - footerTop + 40}px`
        : '40px';
    }
  });
}
